<template>
    <b-modal id="modal-courses" :hide-footer="true" :centered="true" >
        <template #modal-header>
			<img class="close" src="@/assets/img/close_red.png" @click="resetSelectedExam">
        <span>
			<h6 class="sub-title">{{$t('planesYPrecios.paso-2.modal-examen.titulo')}}<span>{{$t('planesYPrecios.paso-2.modal-examen.subTitulo')}}</span></h6>
	  	</span>
		</template>
      	<div class="content-buttons">
        	<b-row align-h="center"> 	
        		<b-col cols="12" v-for="(element, index) in Math.ceil(exams.length/2)" :key="index" :id="'divExams_'+index">
        		    <button v-if="((index)*2)<exams.length" :key="'exam_'+((index-1)+index)" :id="'exam_'+((index)*2)" @click="setSelectedExam(exams[((index)*2)]);" :class="exams[((index)*2)].id === examSelected.id ? 'active' : null" >{{exams[((index)*2)].name}}</button>
        		    <button v-if="((index+1)+index)<exams.length" :key="'exam_'+(index+1)*2" :id="'exam_'+((index+1)+index)" @click="setSelectedExam(exams[((index+1)+index)]);"  :class="exams[((index+1)+index)].id === examSelected.id ? 'active' : null">{{exams[((index+1)+index)].name}}</button>
        		</b-col>
        	</b-row>
      	</div>
		<div class="text-center mt-5">
			<b-button variant="primary" :disabled="!examSelected.id" @click="saveSelectedExam">{{$t('planesYPrecios.paso-2.modal-examen.button')}}</b-button>
		</div>
	</b-modal>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
export default {
	data() {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			exams: [],
			examSelected: this.Exam
		}
	},
	props: {
		Age: {
			type: Number
		},
		Exam: {
			type: Object
		},
		FlagExamenSeleccionado: {
			type: Boolean
		}
	},
	watch: { 
		Exam: function(newVal, oldVal) { // watch it
		 	this.examSelected= this.Exam;
		
		 
		},
		examSelected: function(newVal, oldVal) { // watch it
			 
			//console.log('Prop changed - examSelected: ', newVal, ' | was: ', oldVal);
		 
		}
	},
	created() {
		if(this.Age != null) {
			this.getExamsByAge(this.Age);
		}
	},
	methods: {
		getExamsByAge: function(age) {
			//debugger;
			baseInstanceAxios
			.get(this.API_URL + `/Resources/Subjects/ListExamenByAge?Age=${age}`)
			.then(response => {
				if(response.data != null && response.data.list != null){
					this.exams = response.data.list;
					
				}
			});
		},
		setSelectedExam: function(exam) {
			 
			this.examSelected = {
				name: exam.name,
				id: exam.id,
				programId: exam.programId
			};
			//this.FlagExamenSeleccionado = true;
			//this.$emit('selectedExam',examSelected)
		},
		saveSelectedExam: function() {
		
			this.$emit('saveExamSelected', this.examSelected)
		},
		resetSelectedExam: function() {
			 
            this.examSelected = this.Exam;
			this.$bvModal.hide('modal-courses');
		}
	}

}
</script>